<template>
  <div class="item" @click="toDetail(msg.serviceId)" :class="{ liMargin: isInfo}">
    <img :src="msg.banner" alt="">
    <h3 class="color_51">{{ msg.title }}</h3>
    <ServiceRate :score="msg.totalScore/msg.totalScoreNum" :totalScoreNum="msg.totalScoreNum" class="rate" v-if="isInfo"></ServiceRate>
    <h4 class="mainColor">{{ msg.discountPrice }} <span v-if="msg.discountMark === 1 && isInfo">折后价</span></h4>
    <p class="color_102" v-if="isInfo">原价：{{ msg.originalPrice }}</p>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: Object,
      default: {},
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toDetail(fineServiceId){
      this.$router.push({ path: `/business/recommendInfo/${fineServiceId}`, query:this.$route.query })
    },
  },
}
</script>


<style lang="scss" scoped>
  @import "~@scss";
.item {
  background-color: #fff;
  margin: .32rem;
  border-radius: .053333rem;
  overflow: hidden;
  &.liMargin {
    margin: 0;
  }
  img {
    width: 100%;
    height: px2rem(421);
    border-radius: .053333rem .053333rem 0 0;
    border-bottom: 1px solid #c4c4c4;
  }
  h3 {
    font-size: px2rem(34);
    margin: px2rem(10) px2rem(24) 0 px2rem(24);
  }
  h4 {
    font-size: px2rem(30);
    margin: px2rem(16) px2rem(24);
    span {
      margin-left: px2rem(20);
      border: 1px solid #D9262C;
      border-radius: px2rem(4);
      padding: px2rem(1) px2rem(10);
      font-size: px2rem(12);
    }
  }
  p {
    font-size: px2rem(24);
    margin: 0 px2rem(24);
    color: #666;
    padding-bottom: px2rem(32);
  }
}
.rate{
  padding-left: .2rem;
  padding-top: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/components/RecommendedDemo.vue